import { Skeleton } from '@portalterreno/react-ui-core/Skeleton';
import React from 'react';

import StyledCard from '../FormValues/StyledCard';

const DesktopContactFormSkeleton: React.FC = () => {
  return (
    <StyledCard>
      <Skeleton
        height={69}
        width={229}
        marginBottom={20}
      />
      <Skeleton
        height={21}
        marginBottom={32}
      />
      <Skeleton
        height={21}
        width={109}
        marginBottom={10}
      />
      <Skeleton
        height={48}
        marginBottom={10}
      />
      <Skeleton
        height={21}
        width={109}
        marginBottom={10}
      />
      <Skeleton
        height={48}
        marginBottom={10}
      />
      <Skeleton
        height={21}
        width={109}
        marginBottom={10}
      />
      <Skeleton
        height={48}
        marginBottom={10}
      />
      <Skeleton
        height={21}
        width={109}
        marginBottom={10}
      />
      <Skeleton
        height={119}
        marginBottom={19}
      />
      <Skeleton
        height={48}
        marginBottom={14}
      />
      <Skeleton
        height={80}
        marginBottom={25}
      />
    </StyledCard>
  );
};

export default DesktopContactFormSkeleton;
